import type { RacemapEvent } from '@racemap/utilities/types/events';
import { Button, Flex } from 'antd';
import type { FC } from 'react';
import { Link } from 'react-router';
import { IconCopy, IconFail } from '../BasicComponents/Icons';
import { Tristate } from '../utils/tristateTask';

interface Props {
  onClose: () => void;
  duplicatedEvent: RacemapEvent | null;
  savingState: Tristate;
}

export const Footer: FC<Props> = ({ onClose, duplicatedEvent, savingState }) => {
  return (
    <Flex style={{ marginTop: 20 }} gap={5} justify="flex-end">
      <Button icon={<IconFail />} onClick={onClose} className="racemap_duplicate_event_modal_close">
        Close
      </Button>
      {duplicatedEvent == null ? (
        <Button
          icon={savingState === Tristate.FAILURE ? <IconFail /> : <IconCopy />}
          loading={savingState === Tristate.SPINNING}
          htmlType="submit"
          type="primary"
        >
          Duplicate Tracking Map
        </Button>
      ) : (
        <Link to={`/admin/events/${duplicatedEvent.id}`}>
          <Button>Go to duplicated event</Button>
        </Link>
      )}
    </Flex>
  );
};
